package com.daytimegaming.ourdailyfinances.di

import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration

fun initKoin(enableHttpLogging: Boolean = false, appDeclaration: KoinAppDeclaration = {}) {
    startKoin {
        appDeclaration()
        modules(
            platformModule(),
            networkModule(enableHttpLogging),
            repositoryModule(),
            useCaseModule(),
            viewModelModule(),
        )
    }
}
